module.exports = __externals__;